import {
  Building2Icon,
  HeartIcon as DefaultIcon,
  DumbbellIcon,
  EyeIcon,
  HeartPulseIcon,
  PillIcon,
  ShieldCheckIcon,
  StethoscopeIcon,
  TabletsIcon,
} from 'lucide-react';

import {
  HEALTHCARE_CONFIG,
  HEALTHCARE_KEYWORDS,
  VALID_HEALTHCARE_SUBCATEGORIES,
  detectHealthcareSubcategory,
  detectHealthcareSubcategoryWithConfidence,
} from '@splitfiesta/core';

export {
  HEALTHCARE_CONFIG,
  HEALTHCARE_KEYWORDS,
  VALID_HEALTHCARE_SUBCATEGORIES,
  detectHealthcareSubcategory,
  detectHealthcareSubcategoryWithConfidence,
};

type HealthcareIcon = React.ComponentType<{ className?: string }>;

export const HEALTHCARE_SUBCATEGORY_ICONS: Record<string, HealthcareIcon> = {
  doctor: StethoscopeIcon,
  pharmacy: PillIcon,
  hospital: Building2Icon,
  dental: HeartPulseIcon,
  vision: EyeIcon,
  specialist: HeartPulseIcon,
  insurance: ShieldCheckIcon,
  fitness: DumbbellIcon,
  supplements: TabletsIcon,
  default: DefaultIcon,
};

export function getHealthcareIcon(
  subcategory: string | null | undefined
): HealthcareIcon {
  if (!subcategory || !(subcategory in HEALTHCARE_SUBCATEGORY_ICONS)) {
    return HEALTHCARE_SUBCATEGORY_ICONS.default;
  }
  return HEALTHCARE_SUBCATEGORY_ICONS[subcategory];
}
